import { TerminalState } from '../types';

export const terminalState: TerminalState = {
  terminals: [],
  totalRecordCount: 0,
  search: '',
  addEditModal: {
    isOpen: false,
    terminal: null,
    method: 'add',
  },
  deleteModal: {
    isOpen: false,
    terminal: null,
  },
  csvUploadModal: false,
  exportModalOpen: false,
  subsetModal: false,
};
